import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_DEFAULT_KEY;

if (!supabaseUrl || !supabaseKey) {
  throw new Error(
    'Supabase 환경 변수가 누락되었습니다. 로컬은 .env 파일, 배포 환경은 대시보드 설정을 확인해주세요.'
  );
}

export const supabase = createClient(supabaseUrl, supabaseKey);